import { type StackProps, Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';

import { buildTestId } from '~/utilities/buildTestId';

type Props = {
  message: string;
  submessage?: string;
  testID?: string;
};

export const WideBanner = ({
  message,
  submessage,
  testID,
  ...rest
}: Props & StackProps) => (
  <VStack
    background="$surface.container"
    display="flex"
    flexDirection="row"
    borderStyle="solid"
    borderWidth={1}
    borderColor="$neutral.20"
    borderLeftWidth={0}
    borderRightWidth={0}
    padding="$4"
    marginBottom="$2"
    marginTop="$3"
    testID={testID}
    {...rest}
    marginHorizontal={-14}
  >
    <VStack>
      <IconValidationInvalid color="$support.danger.surfaceOnColorAlt" />
    </VStack>
    <VStack marginLeft="$2" display="flex" flex={1}>
      <Text
        testID={buildTestId({ testID, suffix: ['banner', 'message'] })}
        color="$text.100"
        fontSize="$bodyBase.default"
        fontWeight="$bodyBase.default"
      >
        {message}
      </Text>
      <Text
        testID={buildTestId({ testID, suffix: ['banner', 'submessage'] })}
        color="$text.100"
        fontSize="$bodyBase.default"
        fontWeight="$bodyBase.strong"
      >
        {submessage}
      </Text>
    </VStack>
  </VStack>
);
